import React, { Component } from 'react'
import { UnauthorizedCard } from 'src/components/UnauthorizedCard'
import Navbar from '@softwaredev_cegeka/stix-core/dist/components/Navbar'
import Grid from '@softwaredev_cegeka/stix-core/dist/components/Grid'

class UnauthorizedPage extends Component {
    // keep this outside of the main routes so we don't loop indefinitely
    // when the user is unauthorized
    render() {
        return (
            <>
                <Navbar
                    fixed={'top'}
                    sticky={'top'}
                    bg={'primary'}
                    variant={'dark'}
                >
                    <Navbar.Brand href={'/'}>
                        <img
                            src="https://public.apps.cegeka.com/logos/cegeka-logo-white.svg"
                            alt={'Heimdallr logo'}
                            height="31"
                        />
                    </Navbar.Brand>
                </Navbar>
                <Grid.Container className={'error-page'}>
                    <h1 className={'error-title'}>Unauthorized</h1>
                    <UnauthorizedCard />
                </Grid.Container>
            </>
        )
    }
}

export default UnauthorizedPage
